export const zh_CN = {
  translation: {
    'Welcome to React': '欢迎使用 React',
  },
};
